// extracted by mini-css-extract-plugin
export default {"PrevOffer":"styles_PrevOffer__Nvanf","decline":"styles_decline__MYRZf","dropdownTitle":"styles_dropdownTitle__QgG3G","note":"styles_note__U-5oL","short":"styles_short__DQamL"};